import React from "react";
import { RadioButton } from "@lululemon/ecom-pattern-library-radio-button";

import styles from "../styles/ship-it-to-me-box.module.scss";

const ShipItToMeBox = ({ isChecked, description, radioGroupName, onClick }) => {
  const titleClassName = isChecked
    ? `${styles.title} ${styles.titleChecked}`
    : styles.title;

  return (
    <div className={styles.shipToMeContainer}>
      <RadioButton
        id="ship-it-radio-button"
        name={radioGroupName}
        classes={{
          label: styles.radioButtonLabel
        }}
        checked={isChecked}
        onClick={onClick}
      >
        <p className={titleClassName}>Ship it to me</p>
      </RadioButton>
      <span className={styles.shipToMeText}>{description}</span>
    </div>
  );
};

export default ShipItToMeBox;
